export default __webpack_public_path__ + "files/0d2a54d0d6ddfafdd799576d8059e42c.jpg";